export default __webpack_public_path__ + "static/media/N-03.3226942c.png";